import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductExtended } from '@floori/models';
import { GalleryDialogData, Product } from '@floori-web/models';
import { PagedResponse, ProductFilterResponseDto } from '@floori/models';
import { AssetImageDto, HashMap, ProductRGBAColor } from '@floori-web-components';

export const FLOORI_PRODUCTS_PROVIDER = new InjectionToken('FLOORI_PRODUCTS_PROVIDER');

export interface ProductsProvider {
    cachedProducts$: Observable<HashMap<ProductExtended>>;
    groutProducts$: Observable<Product[]>;
    groutProductsLoading$: Observable<boolean>;
    currentItems$: Observable<PagedResponse<ProductFilterResponseDto> | undefined>;
    productFields$: Observable<string[]>;
    galleryImages$: Observable<string[] | AssetImageDto[]>;
    galleryLoading$: Observable<boolean>;

    fetchInitialProduct(
        productId?: string,
        sku?: string,
        externalId?: string,
        metadata?: string,
    ): void;

    fetchProduct(
        productId: string,
        metadata?: Record<string, unknown>,
        isGrout?: boolean,
    ): Observable<ProductExtended>;

    fetchGroutProducts(
        catalogId: string,
        page: number,
    ): Observable<[PagedResponse<ProductFilterResponseDto>, string]>;

    fetchMosaicProducts(
        catalogId: string,
        page: number,
    ): Observable<[PagedResponse<ProductFilterResponseDto>, string]>;

    setActiveProduct(
        product?: ProductExtended,
        updateVisualization?: boolean,
        additional?: boolean,
        search?: string,
    ): void;

    setProductItems(items: PagedResponse<ProductFilterResponseDto>): void;

    clearProducts(): void;

    randomizePattern(): void;

    getCollectionName(productId: string): Observable<string>;

    updateCollectionMap(productId: string, collectionName: string): void;

    openGalleryDialog(data: GalleryDialogData): void;

    fetchGallery(id: string, image?: AssetImageDto, rgbaColor?: ProductRGBAColor): void;
}
